import React,{useState,useEffect} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useMemo } from 'react';
import DeleteRenderer from "../../Components/UserActions";
import UserManagement from "../../Components/UserManagement";
import AuthUser from '../../AuthUser';
import moment from 'moment';
function Agents() {

   
   const { http, getUser } = AuthUser();
      let userdetails = getUser();
      // Row Data: The data to be displayed.
      const [rowData, setRowData] = useState([]);
   
   const fetchData = () =>{
       http.get(`admin/getAgents/${userdetails.email}`)
       .then((response) => {
           setRowData(response.data.agents)
       })
       .catch()
   }
   useEffect(() =>{
       fetchData();
   },[])
   const refreshData = () =>{
       fetchData()
   
   }
   // Column Definitions: Defines the columns to be displayed.
   const [colDefs, setColDefs] = useState([
        
       
       { headerName:'FirstName',field: "first_name" },
       { field: "Actions",
           cellRenderer: DeleteRenderer, 
           cellRendererParams: {
               refreshData: refreshData, // Pass folder name or other data as custom params
               actionurl:'deleteagent',
               updateStatus:'updateAgentStatus'
           },
           cellStyle: { overflow: "visible", zIndex: "auto" },// Set this line
         resizable: true,
         suppressMenu: true,
         minWidth: 100,
         width: 80 
        },
       { headerName:'LastName',field: "last_name" },   
       { headerName:'Email',field: "email" },
       { headerName:'Phone',field: "phone" },
       { headerName:'Country',field: "country" },
       { headerName:'State',field: "state" },
       { headerName:'NPN',field: "zipcode" },
       { headerName:'Date',field: "created_at",cellRenderer: (params) => {
           return (
             <span>
               {moment(params.data.created_at).format('DD-MMM-YYYY')}
             </span>
           );
         },
    },
   ]);
   
   
   // ...
   const defaultColDef = useMemo(() => {
       return {
           flex: 1,
           filter: true,
       }
   
   });


   
    

    return (
        <Container fluid>         
           <UserManagement/>
          
            <Row className='m-1 pt-2'>
                <Col sm={4} className='d-flex'>
                    <h6 className='fw-bold'>Agents </h6>
                </Col>
                <Col sm={4} className='pb-2'>
                    
                </Col>
                <Col sm={4} >
                    <div class="dropdown float-end">
                      
                    </div>
                </Col>

                <div className="ag-theme-alpine" // applying the grid theme
                     style={{ height: 550 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={colDefs}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10, 20]}
                        defaultColDef={defaultColDef}
                        rowSelection={"multiple"}
                       
                    />
                </div>
                
               
            </Row>
           
        </Container>

    );
}

export default Agents